import React from 'react';
import { ReactComponent as TaskIcon } from '@assets/icons/Onboarding/task.svg';
import { ReactComponent as CollaborateIcon } from '@assets/icons/Onboarding/collaborate.svg';
import { ReactComponent as ApprovalIcon } from '@assets/icons/Onboarding/approval.svg';
import { ReactComponent as AssetIcon } from '@assets/icons/Onboarding/asset.svg';
import { ReactComponent as CampaignIcon } from '@assets/icons/Onboarding/campaign.svg';
import { CompleteOnboardingStepDto } from '@api/Api';

type OnboardingStep = {
  type: CompleteOnboardingStepDto['type'] | 'review-asset';
  title: string;
  description: string;
  button: string;
  icon: React.JSX.Element;
};

export const onboardingSteps: OnboardingStep[] = [
  {
    type: 'create-campaign',
    title: 'Create Your First Project',
    description:
      'Name your project, set access permissions, and start collaborating instantly.',
    button: 'Create project',
    icon: <CampaignIcon className="aw-icon" />
  },
  {
    type: 'upload-asset',
    title: 'Upload Media',
    description:
      'Add videos, images, PDFs, slides, and more — all in one place.',
    button: 'Upload',
    icon: <AssetIcon className="aw-icon" />
  },
  {
    type: 'route-for-approval',
    title: 'Route for Approval',
    description:
      'Automate feedback and approvals across teams and stakeholders.',
    button: 'Route',
    icon: <ApprovalIcon className="aw-icon" />
  },
  {
    type: 'review-asset',
    title: 'Review Media',
    description:
      'Quickly gather feedback on files from teammates, clients, or vendors.',
    button: 'Collaborate',
    icon: <CollaborateIcon className="collaborate-icon" />
  },
  {
    type: 'create-task-from-comment',
    title: 'Turn Feedback into Tasks',
    description:
      'Convert comments into to-dos, assign owners, and keep projects moving.',
    button: 'Create task',
    icon: <TaskIcon className="task-icon" />
  }
];

export function onboardingPercentage(isContributor: boolean, types: string[]) {
  const steps = onboardingSteps.filter((it) => {
    if (isContributor)
      return it.type !== 'route-for-approval' && it.type !== 'create-campaign';
    return true;
  });

  const userComplete = types.filter(
    (it) => steps.findIndex((x) => x.type === it) > -1
  ).length;

  return { total: steps.length, completed: userComplete, steps };
}
